import React, { lazy, Suspense } from 'react';
import Loader from '../../components/Loader/Loader.lazy';

const LazyDashboardHome = lazy(() => import('./DashboardHome'));

const DashboardHome = (props) => (
  <Suspense fallback={<Loader />}>
    <LazyDashboardHome {...props} />
  </Suspense>
);

export default DashboardHome;
